import ReceiveViewContent from './ReceiveViewContent';
import ReceiveViewHeader from './ReceiveViewHeader';

interface IProps {
  address: string;
  onClickCopyBtn: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onClickBackBtn: () => void;
}

const ReceiveView = ({ address, onClickCopyBtn, onClickBackBtn }: IProps) => {
  return (
    <>
      <div className="container">
        <ReceiveViewHeader onClickBackBtn={onClickBackBtn} />
      </div>
      <ReceiveViewContent address={address} onClickCopyBtn={onClickCopyBtn} />
    </>
  );
};

export default ReceiveView;
